import React, { useEffect, useState } from "react";
import "./SpotLight.scss";
import { MdDoubleArrow } from "react-icons/md";
import { assets } from "../Asset/Assets";

import { fetchRealTimeData } from "../../firebase"; 
import { useLocation } from "react-router-dom";
import moment from 'moment-hijri';



// Function to convert a Hijri date to Gregorian
const convertHijriToGregorian = (hijriDate) => {
  // Parse the Hijri date (e.g., "1446/03/25")
  const gregorianDate = moment(hijriDate, 'iYYYY/iMM/iDD').format('YYYY/MM/DD');
  return gregorianDate;
};

// Example usage
// const hijriDate = "1446/03/25"; // Replace this with your actual date input
// const gregorianDate = convertHijriToGregorian(hijriDate);
// console.log(`Gregorian Date: ${gregorianDate}`);




const SpotLight = () => {

  
  const [realTimeData, setRealTimeData] = useState(null);


  const [formattedToday, setFormattedToday] = useState(""); // For today's date
  const [formattedExpiry, setFormattedExpiry] = useState(""); // For expiry date



  const location = useLocation();

  const id = location?.state.id ;

  console.log(location, "location...................")

  console.log(location.state.data,"dataaaaaaaaaaaaaaaa");
  console.log(location.state.id,"iddddddddddddddd");


  document.title = "apps.balady.gov.sa";

  useEffect(() => {
    if (location?.state?.data) {
      setRealTimeData(location.state.data);

    }
  }, [location]);




  useEffect(() => {
    // Listen for real-time updates
   
      setRealTimeData(location.state.data);

  }, []);


  console.log(realTimeData, "dataa")



   

    let out  = (
    <div className="spotlight">
      <div className="spotlight_header"></div>

      <div className="spotlight_form">
        <h2>شهادة صحية سنوية </h2>

        <div className="form_img_wrapper">
          <img src={location.state.photo} alt="" />
        </div>

        <div className="item_container">



          <div className="item_warapper">
            <div className="item">
              <div className="header_item">
                <span>البلدية</span>
              </div>

              <span>   {realTimeData?.Biladi ? realTimeData.Biladi : "بلدية محافظة  القليبه " }  </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>
                الامانة
                    </span>
              </div>

              <span> {realTimeData?.daman ? realTimeData.daman : "أمانة منطقة تبوك" }  </span>
            </div>
          </div>

          <div className="item_warapper">
            <div className="item">
              <div className="header_item">
                <span>رقم الهوية</span>
              </div>

              <span>  { id ? id : ""} </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>
                الاسم
                    </span>
              </div>

              <span> {realTimeData?.Name ? realTimeData.Name : "" }   </span>
            </div>
          </div>






          <div className="item_warapper">
            <div className="item">
              <div className="header_item">
                <span>الجنسية</span>
               

              </div>

              <span> {realTimeData?.nationality ? realTimeData.nationality : "" }  </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>الجنس</span>
              </div>

              <span> {realTimeData?.Jinsi ? realTimeData.Jinsi : "ذكر" }   </span>
            </div>
          </div>





          <div className="item_warapper">
            <div className="item">
              <div className="header_item">
                <span>المهنة</span>
              </div>

              <span> {realTimeData?.job ? realTimeData.job : "عامل" }  </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>رقم الشهادة الصحية
                </span>
              </div>

              <span> {realTimeData?.sample ? realTimeData.sample : "450413699963" }</span>
            </div>
          </div>


          <div className="item_warapper">
            <div className="item">
              <div className="header_item">
                <span>
                تاريخ إصدار الشهادة الصحية ميلادي

                </span>
              </div>

              <span> {convertHijriToGregorian(realTimeData?.today) ? convertHijriToGregorian(realTimeData?.today) : "" } </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>تاريخ إصدار الشهادة الصحية هجري
                </span>
              </div>

              <span>  {realTimeData?.today ? realTimeData.today : "" } </span>
            </div>
          </div>





          <div className="item_warapper">
            <div className="item">
              <div className="header_item">
                <span>تاريخ نهاية الشهادة الصحية ميلادي
                </span>
              </div>

              <span>  {convertHijriToGregorian(realTimeData?.expiry) ? convertHijriToGregorian(realTimeData?.expiry) : "" }  </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>تاريخ نهاية الشهادة الصحية هجري
                </span>
              </div>

              <span>   {realTimeData?.expiry  ? realTimeData.expiry  : "" } </span>
            </div>
          </div>

          <div className="item_warapper">
            <div className="item">
              <div className="header_item">
                <span>تاريخ انتهاء البرنامج التثقيفى
                </span>
              </div>

              <span>  {realTimeData?.Thansfeeq  ? realTimeData.Thansfeeq  : "" } </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>نوع البرنامج التثقيفى
                </span>
              </div>

              <span> {realTimeData?.Noog  ? realTimeData.Noog  : "" }   </span>
            </div>
          </div>


                    <div className="item_warapper">

                      
            <div className="item">
              <div className="header_item">
                <span>اسم المنشآة
                </span>
              </div>

              <span>  {realTimeData?.IsmManshath ? realTimeData.IsmManshath : "" }     </span>
            </div>

            <div className="item">
              <div className="header_item">
                <span>رقم الرخصة
                </span>
              </div>

              <span> {realTimeData?.Raksath ? realTimeData.Raksath : "" } </span>
            </div>


          </div>


          <div className="item_warapper_last">
            <div className="item_last">
              <div className="header_item">
                <span>رقم المنشآة 
                </span>
              </div>

              <span>  {realTimeData?.Manshath ? realTimeData.Manshath : "" }  </span>
            </div>

</div>





        </div>
      </div>
    </div>
  );



//     let out  = (
//     <div className="spotlight">
//       <div className="spotlight_header"></div>

//       <div className="spotlight_form">
//         <h2>شهادة صحية سنوية </h2>

//         <div className="form_img_wrapper">
//           <img src={location.state.photo} alt="" />
//         </div>

//         <div className="item_container">



//           <div className="item_warapper">
//             <div className="item">
//               <div className="header_item">
//                 <span>البلدية</span>
//               </div>

//               <span>   {realTimeData?.Biladi ? realTimeData.Biladi : "بلدية محافظة  القليبه " }  </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>
//                 الامانة
//                     </span>
//               </div>

//               <span> {realTimeData?.daman ? realTimeData.daman : "أمانة منطقة تبوك" }  </span>
//             </div>
//           </div>

//           <div className="item_warapper">
//             <div className="item">
//               <div className="header_item">
//                 <span>رقم الهوية</span>
//               </div>

//               <span>  { id ? id : ""} </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>
//                 الاسم
//                     </span>
//               </div>

//               <span> {realTimeData?.Name ? realTimeData.Name : "" }   </span>
//             </div>
//           </div>






//           <div className="item_warapper">
//             <div className="item">
//               <div className="header_item">
//                 <span>الجنسية</span>
               

//               </div>

//               <span> {realTimeData?.nationality ? realTimeData.nationality : "" }  </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>الجنس</span>
//               </div>

//               <span> ذكر  </span>
//             </div>
//           </div>





//           <div className="item_warapper">
//             <div className="item">
//               <div className="header_item">
//                 <span>المهنة</span>
//               </div>

//               <span> {realTimeData?.job ? realTimeData.job : "عامل" }  </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>رقم الشهادة الصحية
//                 </span>
//               </div>

//               <span> {realTimeData?.sampleNo ? realTimeData.sampleNo : "450413699963" }</span>
//             </div>
//           </div>


//           <div className="item_warapper">
//             <div className="item">
//               <div className="header_item">
//                 <span>
//                 تاريخ إصدار الشهادة الصحية ميلادي

//                 </span>
//               </div>

//               <span> {convertHijriToGregorian(realTimeData?.today) ? convertHijriToGregorian(realTimeData?.today) : "" } </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>تاريخ إصدار الشهادة الصحية هجري
//                 </span>
//               </div>

//               <span>  {realTimeData?.today ? realTimeData.today : "" } </span>
//             </div>
//           </div>





//           <div className="item_warapper">
//             <div className="item">
//               <div className="header_item">
//                 <span>تاريخ نهاية الشهادة الصحية ميلادي
//                 </span>
//               </div>

//               <span>  {convertHijriToGregorian(realTimeData?.expiry) ? convertHijriToGregorian(realTimeData?.expiry) : "" }  </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>تاريخ نهاية الشهادة الصحية هجري
//                 </span>
//               </div>

//               <span>   {realTimeData?.expiry  ? realTimeData.expiry  : "" } </span>
//             </div>
//           </div>

//           <div className="item_warapper">
//             <div className="item">
//               <div className="header_item">
//                 <span>تاريخ انتهاء البرنامج التثقيفى
//                 </span>
//               </div>

//               <span>  {realTimeData?.Thansfeeq  ? realTimeData.Thansfeeq  : "" } </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>نوع البرنامج التثقيفى
//                 </span>
//               </div>

//               <span> {realTimeData?.Noog  ? realTimeData.Noog  : "" }   </span>
//             </div>
//           </div>


//                     <div className="item_warapper">

                      
//             <div className="item">
//               <div className="header_item">
//                 <span>اسم المنشآة
//                 </span>
//               </div>

//               <span>   الشركة ابتكارات التأثير للتجارة      </span>
//             </div>

//             <div className="item">
//               <div className="header_item">
//                 <span>رقم الرخصة
//                 </span>
//               </div>

//               <span> {realTimeData?.Raksath ? realTimeData.Raksath : "451015467977" } </span>
//             </div>


//           </div>


//           <div className="item_warapper_last">
//             <div className="item_last">
//               <div className="header_item">
//                 <span>اسم المنشآة 
//                 </span>
//               </div>

//               <span>  {realTimeData?.Manshath ? realTimeData.Manshath : "7035463566" }  </span>
//             </div>

// </div>





//         </div>
//       </div>
//     </div>
//   );

 let out3 = (<div className="spotlight">
    <div className="spotlight_header"></div>
  
    <div className="spotlight_form">
      <h2>شهادة صحية سنوية </h2>
  
      <div className="form_img_wrapper">
        <img src={location.state.photo} alt="" />
      </div>
  
      <div className="item_container">
  
        <div className="item_warapper">
          <div className="item">
            <div className="header_item">
              <span>البلدية</span>
            </div>
  
            <span>{realTimeData?.submuncipality ? realTimeData.submuncipality : "بلدية محافظة القليبه"}</span>
          </div>
  
          <div className="item">
            <div className="header_item">
              <span>الامانة</span>
            </div>
  
            <span>{realTimeData?.muncipaliy ? realTimeData.muncipaliy : "أمانة منطقة تبوك"}</span>
          </div>
        </div>
  
        <div className="item_warapper">
          <div className="item">
            <div className="header_item">
              <span>رقم الهوية</span>
            </div>
  
            <span>{id ? id : ""}</span>
          </div>
  
          <div className="item">
            <div className="header_item">
              <span>الاسم</span>
            </div>
  
            <span>{realTimeData?.Name ? realTimeData.Name : ""}</span>
          </div>
        </div>
  
        <div className="item_warapper">
          <div className="item">
            <div className="header_item">
              <span>الجنسية</span>
            </div>
  
            <span>{realTimeData?.nationality ? realTimeData.nationality : ""}</span>
          </div>
  
          <div className="item">
            <div className="header_item">
              <span>الجنس</span>
            </div>
  
            <span>{realTimeData?.Jinsi ? realTimeData.Jinsi : "ذكر" } </span>
          </div>
        </div>
  
        <div className="item_warapper">
          <div className="item">
            <div className="header_item">
              <span>المهنة</span>
            </div>
  
            <span>{realTimeData?.job ? realTimeData.job : "عامل"}</span>
          </div>
  
          <div className="item">
            <div className="header_item">
              <span>رقم الشهادة الصحية</span>
            </div>
  
            <span>{realTimeData?.sample ? realTimeData.sample : "450413699963"}</span>
          </div>
        </div>
  
        <div className="item_warapper">
          <div className="item">
            <div className="header_item">
              <span>تاريخ انتهاء الشهادة الصحية</span>
            </div>
  
            <span>{realTimeData?.today ? realTimeData.today : ""}</span>
          </div>
  
          <div className="item">
            <div className="header_item">
              <span>تاريخ إصدار الشهادة الصحية</span>
            </div>
  
            <span>{realTimeData?.expiry ? realTimeData.expiry : ""}</span>
          </div>
        </div>
  
        <div className="item_warapper">
          <div className="item">
            <div className="header_item">
              <span>تاريخ انتهاء البرنامج التثقيفى</span>
            </div>
  
            <span>{realTimeData?.afterThree ? realTimeData.afterThree : ""}</span>
          </div>
  
          <div className="item">
            <div className="header_item">
              <span>نوع البرنامج التثقيفى</span>
            </div>
  
            <span>{realTimeData?.Noog ? realTimeData.Noog : ""}</span>
          </div>
        </div>
  
        <div className="item_warapper">
          <div className="item">
            <div className="header_item">
              <span>اسم المنشآة</span>
            </div>
  
            <span>{realTimeData?.comapnyname ? realTimeData.comapnyname : ""}</span>
          </div>
  
          <div className="item">
            <div className="header_item">
              <span>رقم رخصة المنشأة</span>
            </div>
  
            <span>{realTimeData?.companynumber ? realTimeData.companynumber : ""}</span>
          </div>
        </div>
  
        <div className="item_warapper_last">
          <div className="item_last">
            <div className="header_item">
              <span>رقم المنشآة</span>
            </div>
  
            <span>{realTimeData?.licencenumber ? realTimeData.licencenumber : ""}</span>
          </div>
        </div>
  
      </div>
    </div>
  </div>
  );


  return realTimeData?.licencenumber ? out3:out;
};

export default SpotLight;
